<template>
  <div>
    <Card>
      <Row>
        <el-button v-if="me.role === $t('libs_util_102')"
                   size="medium"
                   class="filter-item"
                   type="primary"
                   @click="add">{{$t('pages_banners_index_178')}}</el-button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="promote_companies"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           :loading="addingCompany"
           @on-ok="handleSubmit"
           :title="`${formType === 'new' ? $t('pages_banners_index_178') : $t('pages_products_edit_829')}推广公司`">
      <Form ref="promote_company"
            :model="form"
            :rules="formRules"
            :label-width="120">
        <Form-item :label="$t('pages_promote_companies_873')"
                   prop="name">
          <Input type="text"
                 v-model="form.name" />
        </Form-item>
        <Form-item :label="$t('pages_promote_companies_874')"
                    prop="users_shop_id">
            <Select v-model="form.users_shop_id">
              <Option :value="user.id" v-for="user in users_shops" :key="user.id">{{user.username || user.role}} [{{user.user_display_mobile}}]</Option>
            </Select>
        </Form-item>
        <FormItem :label="$t('pages_promote_companies_875')"
                  prop="rebate_pattern">
          <i-select v-model="form.rebate_pattern">
            <i-option v-for="item in promote_types"
                      :key="item.id"
                      :value="item.value">{{item.name}}</i-option>
          </i-select>
        </FormItem>
        <template v-if="form.rebate_pattern === 'rate'">
          <FormItem :label="$t('pages_promote_companies_876')"
                    prop="rebate_rate">
            <i-input v-model="form.rebate_rate"
                    type="number"
                    :placeholder="$t('pages_promote_companies_877')">
              <span slot="append">%</span>
            </i-input>
          </FormItem>
        </template>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  watch: {
    promote_company (val) {
      if (val && val.id) {
        this.form = val
      }
    }
  },
  data () {
    return {
      form: {
        name: '',
        rebate_pattern: 'none'
      },
      formRules: {
        name: [{ required: true, message: i18n.t('pages_booking_store_products_index_216') }],
        users_shop_id: [{ required: true, message: i18n.t('pages_promote_companies_878') }],
        rebate_pattern: [{ required: true, message: i18n.t('pages_promote_companies_879') }],
      },
      modalShow: false,
      addingCompany: true,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_promote_bill_info_869'),
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_promote_companies_873'),
          key: 'name'
        },
        {
          title: i18n.t('pages_promote_companies_874'),
          key: 'users_shop_id',
          render: (h, params) => {
            const user = _.find(this.users_shops, { id: params.row.users_shop_id }) || {}
            return <span>{user.username || user.role} [{user.user_display_mobile}]</span>
          }
        },
        {
          title: i18n.t('pages_promote_companies_875'),
          key: 'rebate_pattern',
          render: (h, params) => {
            const type = _.find(this.promote_types, { value: params.row.rebate_pattern }) || {}
            return <span>{type.name}</span>
          }
        },
        {
          title: i18n.t('pages_promote_companies_880'),
          key: 'rebate_rate',
          render: (h, params) => {
            return <span>{params.row.rebate_pattern === 'rate' ? params.row.rebate_rate : '-'}</span>
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 270,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            if (this.me.role === i18n.t('libs_util_102')) {
              children.push(editorButtonInTable(this, h, params), deleteButtonInTable(this, h, params))
            }
            children.push(
              commonButtonInTable(
                this,
                h,
                'warning',
                i18n.t('pages_promote_companies_881'),
                this.generateBill,
                [params.row.id]
              ),
              commonButtonInTable(
                this,
                h,
                'success',
                i18n.t('pages_promote_companies_882'),
                this.checkBills,
                [params.row.id]
              )
            )
            return h('div', children)
          }
        }
      ],
      promote_types: [{
        id: 1,
        name: i18n.t('pages_promote_companies_883'),
        value: 'none'
      }, {
        id: 2,
        name: i18n.t('pages_promote_companies_884'),
        value: 'rate'
      }, {
        id: 3,
        name: i18n.t('pages_promote_companies_885'),
        value: 'product'
      }]
    }
  },
  created () {
    this.changePage(1)
    // this.changeUsersQuery({ per: 100 })
    this.usersIndex({ page: 1, per: 100 })
  },
  computed: {
    ...mapGetters('promote_company', ['promote_company', 'promote_companies', 'meta', 'loading']),
    ...mapGetters('users_shop', ['users_shops']),
    ...mapGetters('editor', ['me']),
  },
  methods: {
    ...mapActions('promote_company', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'generate_bill'
    ]),
    ...mapActions('users_shop', { usersIndex: 'index' }),
    ...mapMutations('promote_company', ['changeQuery']),
    // ...mapMutations('users_shop', { changeUsersQuery: 'changeQuery' }),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    },
    add () {
      this.clearRecord()
      this.form = {
        rebate_pattern: 'none'
      }
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      this.$refs.promote_company.validate(async valid => {
        if (!valid) {
          this.addingCompany = false
          this.$nextTick(() => {
            this.addingCompany = true
          })
          return
        }

        if (this.formType === 'edit') {
          await this.update(this.form)
        } else if (this.formType === 'new') {
          await this.create(this.form)
        }
        this.modalShow = false
      })
    },
    generateBill (id) {
      this.$prompt(i18n.t('pages_promote_companies_886'), i18n.t('pages_promote_companies_887'), {
        confirmButtonText: i18n.t('pages_combo_index_284'),
        cancelButtonText: i18n.t('pages_city_shop_freights_index_250'),
        inputPattern: /./,
        inputErrorMessage: i18n.t('pages_promote_companies_886')
      }).then(({ value }) => {
        this.generate_bill({
          id,
          description: value
        })
      })
    },
    checkBills (id) {
      this.$router.push(`/promote/company/${id}/bills`)
    }
  }
}
</script>
